import { FC, ReactElement, ReactNode } from 'react'
import Table2 from 'components/molecules/tables/Table2'

type RewardDetailsTableHeaderProps = {
  zeroState: boolean
}

const RewardDetailsTableHeader: FC<RewardDetailsTableHeaderProps> = ({ zeroState }) => {
  const renderHeadCell = (
    name: string,
    content: ReactNode
  ): ReactElement => {
    return (
      <Table2.HeadCell name={ name }>
        { !zeroState && content }
      </Table2.HeadCell>
    )
  }
  return (
    <Table2.HeadRow>
      { renderHeadCell('name', 'Name') }
      { renderHeadCell('amount', 'Amount') }
      { renderHeadCell('progress', 'Progress') }
      { renderHeadCell('status', 'Status') }
      { renderHeadCell('last_updated', 'Last Updated') }
      { renderHeadCell('dismiss', null) }
    </Table2.HeadRow>
  )
}

export default RewardDetailsTableHeader
